import { Component } from '@angular/core';
import { DialogContentBase } from '@progress/kendo-angular-dialog';
import * as svgIcons from '@progress/kendo-svg-icons';

@Component({
  selector: 'app-pop-password',
  templateUrl: './pop-password.component.html',
  styleUrls: ['./pop-password.component.scss'],
})
export class PopPasswordComponent extends DialogContentBase {
  public allIcons = svgIcons;

  confirmPassword = '';
  newPassword = '';
  oldPassword = '';
  modifySelf = false;

  errorKey!: string;

  close() {
    this.dialog.close();
  }

  changePassword() {
    this.errorKey = '';
    if (this.modifySelf && this.oldPassword == '') this.errorKey = 'Vous devez entrer votre mot de passe courant.';
    else if (this.newPassword.length < 8) this.errorKey = 'Vous devez entrer au moins 8 caractères.';
    else if (this.newPassword != this.confirmPassword) this.errorKey = 'Vous devez entrer 2 fois le même mot de passe.';
    else if (/[A-Z]/.test(this.newPassword) == false) this.errorKey = 'Vous devez entrer au moins un lettre majuscule.';
    else if (/[a-z]/.test(this.newPassword) == false) this.errorKey = 'Vous devez entrer au moins un lettre minuscule.';
    else if (/[0-9]/.test(this.newPassword) == false) this.errorKey = 'Vous devez entrer au moins un chiffre.';
    else if (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(this.newPassword) == false) this.errorKey = 'Vous devez entrer au moins un caractère spécial.';
    else this.dialog.close(true);
  }
}
